import { useState } from "react";
import { api } from "@/lib/api";
import { toast, Toaster } from "sonner";
import { Sparkles, Bot, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function CareerCoach() {
  const { user } = useAuth();
  const [advice, setAdvice] = useState("");
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/ai/career-coach");
      setAdvice(data.advice || "");
    } catch (e) { toast.error("Failed to load coaching"); }
    finally { setLoading(false); }
  };

  return (
    <div className="nh-container py-14">
      <Toaster position="top-center"/>
      <span className="nh-tag bg-nh-pink"><Bot size={12} className="mr-1"/>AI Career Coach · Powered by Claude</span>
      <h1 className="font-display font-black text-4xl sm:text-5xl mt-3">Your personal career coach.</h1>
      <p className="text-nh-muted mt-2 max-w-2xl">Get age-appropriate advice on next jobs, free certifications, volunteer work, and resume upgrades based on your profile.</p>

      <div className="mt-8 nh-card p-6">
        <div className="flex items-start justify-between flex-wrap gap-3">
          <div>
            <h2 className="font-display font-black text-2xl">Ready to level up?</h2>
            <p className="text-sm text-nh-muted mt-1">
              We'll use: <b>age {user?.age || "—"}</b>, <b>grade {user?.grade_level || "—"}</b>, skills, interests, transportation, and location.
              Make sure your <a className="underline" href="/dashboard">profile</a> is filled out.
            </p>
          </div>
          <button onClick={run} disabled={loading} className="nh-btn nh-btn-primary" data-testid="coach-run">
            {loading ? <><Loader2 size={14} className="animate-spin"/> Coaching…</> : <><Sparkles size={14}/> Get My Plan</>}
          </button>
        </div>
        {advice && (
          <div className="mt-6 prose-nh nh-card bg-nh-bg p-5 shadow-none whitespace-pre-line" data-testid="coach-advice">
            {advice}
          </div>
        )}
      </div>

      <div className="mt-8 grid md:grid-cols-3 gap-5">
        {[
          { t: "Free Certificates", d: "Google, LinkedIn, Coursera — many are free for students. Great for your resume." },
          { t: "Volunteer 4 hrs/mo", d: "Local library, food bank, animal shelter — service hours matter for college & jobs." },
          { t: "Start a mini-biz", d: "Babysitting, tutoring, pet care, lawn care — you can start earning today." },
        ].map((c,i)=>(
          <div key={i} className="nh-card p-5">
            <h3 className="font-display font-black text-xl">{c.t}</h3>
            <p className="text-sm mt-2 text-nh-muted">{c.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
